import { Box } from '@mui/material';

import { ApiWorkflowDialog, TextField } from '@verantos-dev/shared-components';

import { useCreateCohortModal } from '../../hooks/useCreateCohortModal';

export const CreateCohortModal = () => {
  const {
    title,
    closeCreateCohortModal,
    createCohortModalContentMessages,
    onSubmit,
    createCohortError,
    isCreateCohortLoading,
    cohortName,
    onChangeCohortName,
    isValidToSubmit,
    apiWorkflowDialogMessages,
    onRedirectAfterSubmit,
  } = useCreateCohortModal();

  return (
    <ApiWorkflowDialog
      id="createCohortModel"
      title={title}
      dialogMessages={apiWorkflowDialogMessages}
      onClose={closeCreateCohortModal}
      onSubmit={onSubmit}
      onRetrySubmit={onSubmit}
      isValidForSubmit={isValidToSubmit}
      isSubmitting={isCreateCohortLoading}
      submittingError={createCohortError}
      onRedirectAfterSubmit={onRedirectAfterSubmit}
      hideDisplayButtonsOnSuccess
    >
      <Box style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
        <Box sx={(theme) => ({ height: theme.spacing(1) })} />
        <TextField
          id="cohort-name-input"
          displayLabel={createCohortModalContentMessages.cohortNameLabel}
          value={cohortName}
          placeholder={createCohortModalContentMessages.cohortNamePlaceholder}
          onChange={onChangeCohortName}
          maxCharacters={60}
          maxCharacterErrorMsg={createCohortModalContentMessages.maxCharacterErrorMsg}
          displayNumCharacter
          width="auto"
          beepMaxCharacters
        />
      </Box>
    </ApiWorkflowDialog>
  );
};
